import React, { Component, CSSProperties } from "react";
import { classNames } from "primereact/utils";
import { Upload, Loader2, ImagePlus } from "lucide-react";
import { utils } from "../../utils/utils";

export interface ImageProps {
    className?: string;
    imageStyle?: CSSProperties | undefined;
    imageClassName?: string;
    src?: string;
    alt?: string;
    width?: string;
    height?: string;
    onImageSelected: (image: File) => void;
    fileInput: (input: boolean) => void;
    photoUploading?: boolean;
}

interface State {
    isHovered: boolean;
}

export class ProfileImage extends Component<ImageProps, State> {
    imageInput: HTMLInputElement | null = null;

    constructor(props: ImageProps) {
        super(props);
        this.state = {
            isHovered: false,
        };
    }

    onImageSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files as FileList;
        if (files.length > 0) {
            const image = files[0];
            if (!utils.checkCharacterlength(image.name) && this.imageInput) {
                this.props.fileInput(false);
                this.imageInput.value = "";
            } else {
                this.props.onImageSelected(image);
            }
        }
    };

    render() {
        const { alt, width, height } = this.props;
        const { isHovered } = this.state;

        const hasSrc = (this.props.src?.length ?? 0) > 0;
        const isCircular = this.props.className?.includes("rounded-circle");
        const containerClassName = classNames("relative overflow-hidden", isCircular ? "rounded-full" : "rounded-lg", hasSrc ? "inline-block" : "block", this.props.className);

        const overlayStyle: CSSProperties = {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: isHovered ? "#00000075" : "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "inherit",
        };

        const uploadIconStyle: CSSProperties = {
            color: "white",
            fontSize: "2rem",
            cursor: "pointer",
            opacity: isHovered ? 1 : 0,
        };

        return (
            <span
                className={containerClassName}
                style={{
                    position: "relative",
                    display: hasSrc ? "inline-block" : "block",
                }}
                onMouseEnter={() => this.setState({ isHovered: true })}
                onMouseLeave={() => this.setState({ isHovered: false })}
            >
                <input
                    ref={(el) => (this.imageInput = el)}
                    type="file"
                    style={{ display: "none" }}
                    accept="image/*"
                    onChange={this.onImageSelected}
                    disabled={this.props.photoUploading}
                />

                {(this.props.src?.length ?? 0) > 0 ? (
                    <img
                        src={this.props.src}
                        className={this.props.imageClassName}
                        width={width}
                        height={height}
                        style={{ display: "block", ...this.props.imageStyle }}
                        alt={alt}
                    />
                ) : (
                    <div
                        className={classNames(
                            "flex items-center justify-center bg-neutral-100 dark:bg-neutral-800 border-2 border-dashed border-neutral-300 dark:border-neutral-600",
                            this.props.className?.includes("rounded-circle") ? "rounded-full" : "rounded-lg",
                            this.props.imageClassName,
                        )}
                        style={{ width: width || "100%", aspectRatio: "1", ...this.props.imageStyle }}
                    >
                        <ImagePlus size={32} strokeWidth={1.5} className="text-neutral-400 dark:text-neutral-500" />
                    </div>
                )}

                <div style={overlayStyle} onClick={() => this.imageInput?.click()}>
                    {this.props.photoUploading
                        ? <Loader2 size={32} className="animate-spin" style={uploadIconStyle} />
                        : <Upload size={32} style={uploadIconStyle} />
                    }
                </div>
            </span>
        );
    }
}
